import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FilledInput from '@material-ui/core/FilledInput';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MUISelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import classnames from 'classnames';
import SelectStyles from './Select.styles';

export class Select extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  constructor(props) {
    super(props);
    this.state = {
      currentOption: props.defaultValue
    };
  }

  componentDidUpdate() {
    if (this.state.currentOption !== this.props.defaultValue) {
      this.setState({ currentOption: this.props.defaultValue });
    }
  }

  _handleChange = ({ target: { name, value } }) => {
    this.setState({ currentOption: value });

    this.props.onChange &&
      this.props.onChange({
        target: {
          name,
          value:
            this.props.options.find(
              option =>
                option.title === value || option.value + '' === value + ''
            ).value || ''
        }
      });
  };

  render() {
    const {
      classes,
      name,
      label,
      inputLabel,
      options = [],
      defaultValue
    } = this.props;

    const hasCustomValue = !options.find(
      option => option.value === defaultValue
    );

    return (
      <FormControl
        variant="filled"
        className={classnames(classes.formControl, classes.root)}
      >
        {label && !inputLabel && (
          <FormLabel
            className={classes.label}
            classes={{ focused: classes.label }}
          >
            {label}
          </FormLabel>
        )}
        {inputLabel && !label && (
          <InputLabel
            className={classnames(classes.label, {
              [classes.inputLabel]: !!inputLabel
            })}
            classes={{ focused: classes.label }}
          >
            {inputLabel}
          </InputLabel>
        )}

        <MUISelect
          value={defaultValue || undefined}
          name={name}
          onChange={this._handleChange}
          input={
            <FilledInput
              name={name}
              id={name}
              disableUnderline={true}
              classes={{
                root: classnames(classes.filledInputRoot, {
                  [classes.filledInputWithInputLabel]: !!inputLabel
                })
              }}
            />
          }
          classes={{
            select: classnames(
              classes.filterColor,
              classes.font,
              classes.select,
              {
                [classes.withInputLabel]: !!inputLabel
              }
            ),
            icon: classnames(classes.filterColor, classes.icon)
          }}
        >
          {hasCustomValue && (
            <MenuItem value={this.state.currentOption}>
              {this.state.currentOption}
            </MenuItem>
          )}

          {options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </MUISelect>
      </FormControl>
    );
  }
}

export default withStyles(SelectStyles)(Select);
